// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1OoRH","dragIcon":"SortableItem_dragIcon__2rDJ2","disabled":"SortableItem_disabled__1tE0l"};